import { Box, Typography } from "@mui/material"
import { RecallData } from "api/delek"
import styled from "styled-components"
import { ContentItemType } from "typings/contentPage"

const StyledItemWrapper = styled(Box)`
  & + & {
    padding-top: 32px;
    border-top: 1px solid #999999;
  }
`

const StyledResponse = styled(Box)<{ $columns: number }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns},1fr)`};
  grid-gap: 35px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`

const StyledItem = styled(Box)<{ $hasBorder: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 35px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`
const StyledTextContainer = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    display: flex;
    grid-gap: 13px;
  }
`

const StyledTopText = styled.p`
  margin: 0;
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 160%;
  /* identical to box height, or 32px */

  letter-spacing: 0.03em;

  /* primary/black */

  color: ${(p) => p.theme.colors.black};
`

const StyledSubText = styled.p`
  margin: 0;

  font-family: MazdaType, OENaPro, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 150%;
  /* identical to box height, or 27px */

  /* primary/black */

  color: ${(p) => p.theme.colors.black};
`

const StyledHeader = styled.h2`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  margin: 0;
  letter-spacing: 0.05em;

  color: ${(p) => p.theme.colors.black};
  margin-bottom: 10px;
`

type Props = {
  item: RecallData
  type: ContentItemType
  length: number
}

const recallFields = {
  licenseNumber: "מספר רכב",
  chassisNumber: "מספר שילדה",
  // id: "מספר קריאה", // commented out for ticket #DMFMC-1838
  shortName: "תיאור",
}

const warrantyFields = {
  licenseNumber: "מספר רכב",
  chassisNumber: "מספר שילדה",
  // id: "מספר קריאה", // commented out for ticket #DMFMC-1838
  phenomenonDesc: "תיאור",
}

const colorFields = {
  licenseNumber: "מספר רכב",
  colorCode: "קוד צבע",
  colorName: "תיאור צבע",
}

const RecallItem = ({ item, type, length }: Props) => {
  const fieldsToMap =
    type === ContentItemType.COLOR
      ? colorFields
      : type === ContentItemType.WARRANTYEXTENSION
      ? warrantyFields
      : recallFields
  const normalizeLeadingDot = (s: string) => {
    const str = String(s ?? "")

    // remove any leading spaces, then check for leading dot
    const trimmedStart = str.replace(/^\s+/, "")

    if (trimmedStart.startsWith(".")) {
      const withoutLeadingDot = trimmedStart.replace(/^\.+\s*/, "") // remove leading dot(s) + following spaces
      // add a dot at the end only if it doesn't already end with one
      return withoutLeadingDot.trimEnd().endsWith(".")
        ? withoutLeadingDot
        : `${withoutLeadingDot}.`
    }

    return str
  }

  return (
    <StyledItemWrapper>
      {length > 1 && <StyledHeader> קריאה מספר {item.numberCol}</StyledHeader>}
      <StyledItem $hasBorder={type !== ContentItemType.COLOR}>
        <StyledResponse $columns={type === ContentItemType.COLOR ? 3 : 2}>
          {Object.keys(fieldsToMap).map((it, index) => (
            <StyledTextContainer key={index.toString()}>
              <StyledTopText>{fieldsToMap[it]}:</StyledTopText>
              <StyledSubText>{item[it]}</StyledSubText>
            </StyledTextContainer>
          ))}
        </StyledResponse>
        {type !== ContentItemType.COLOR ? (
          <Box>
            <Box>
              <Typography variant="body1" fontWeight={700}>
                מהות הקריאה
              </Typography>
            </Box>

            <Box>{normalizeLeadingDot(item.description)}</Box>
          </Box>
        ) : null}
      </StyledItem>
    </StyledItemWrapper>
  )
}

export default RecallItem
